<template>
  <div class="DashboardSettingsComponent">

    <b-form>
      {{ isAgent }}
      <b-form-checkbox-group 
        v-model="selected" 
        :options="appConf.status.isLM && isAgent ? optionsAgent : options"
        class="mb-3" value-field="item" text-field="name" disabled-field="notEnabled" stacked></b-form-checkbox-group>


    </b-form>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: "DashboardSettingsComponent",
  components: {



  },
  props:{
    lang: Object
  },
  data () {
    return {
      

      selected: [
        "MyTasks",
        "LibStatuses",
        "ActiveParts",
        "PendingParts",
        "EndOfParts",
        "ActiveLibraries",
        "PendingLibraries",
        "RoHSParts",
      ],
      options: [
          { item: 'MyTasks', name: this.lang.label_MyTasks },
          //{ item: 'LibStatuses', name: this.lang.label_StatusesOfLibraries },
          { item: 'ActiveParts', name: this.lang.label_ActiveParts },
          { item: 'PendingParts', name: this.lang.label_PendingParts },
          { item: 'EndOfParts', name: this.lang.label_EndOfParts },
          { item: 'ActiveLibraries', name: this.lang.label_ActiveLibraries },
          { item: 'PendingLibraries', name: this.lang.label_PendingLibraries },
          { item: 'RoHSParts', name: this.lang.label_RoHSParts },

      ],
      optionsAgent: [
        { item: 'MyTasks', name: this.lang.label_MyTasks },
        { item: 'LibStatuses', name: this.lang.label_StatusesOfLibraries },
        { item: 'ActiveParts', name: this.lang.label_ActiveParts },
        { item: 'PendingParts', name: this.lang.label_PendingParts },
        { item: 'EndOfParts', name: this.lang.label_EndOfParts },
        { item: 'ActiveLibraries', name: this.lang.label_ActiveLibraries },
        { item: 'PendingLibraries', name: this.lang.label_PendingLibraries },
        { item: 'RoHSParts', name: this.lang.label_RoHSParts },

      ]
    }
  },
  computed: {
    ...mapGetters([
      'appConf',
      'isAgent',
     
    ]),
    
  },
  created() {
    
    const obj = this.$store.getters.d_widgetsSettings;
    this.selected = [];
    
    for(let el in obj){
        
        if (obj[el]){
            this.selected.push(el);
        }
        
    }
    
      

  },
  updated(){
    
  },
  watch: {
    selected: function (newVal, oldVal) {
        
      const obj = {
        MyTasks: false,
        LibStatuses: false,
        ActiveParts: false,
        PendingParts: false,
        EndOfParts: false,
        ActiveLibraries: false,
        PendingLibraries: false,
        RoHSParts: false,
            
            
        }
        for (let i = 0, lei = newVal.length; i < lei; i++){
            
                obj[newVal[i]] = true;
            
        }
        
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_setWidgetsSettings", obj);
    }
  },
  methods: {

  }
}
</script>
<style lang="scss">
  .DashboardSettingsComponent{

  }



</style>



// WEBPACK FOOTER //
// src/components/shared/DashboardSettingsComponent.vue